import React, { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import Card from '../ui-elements/Card'



type Props = {
  jpegString: string
}

function PhotoPreview({
  jpegString,
}: Props) {




  const { t } = useContext(GlobalContext)
  return (
    <Card>
      <div className={`w-full flex flex-col gap-4 justify-center items-center`}>
        <p className={`text-left font-righteous text-brandblue text-xl`}>
          {t('QuestionPages.PhotoPreview.photoCaptured')}
        </p>
        <div className={`w-full flex flex-col gap-3 items-center`}>
          <img
            src={jpegString}
            className={`rounded`}
            style={{ maxHeight: '60vh' }}
            alt={''}
          />
        </div>
      </div>
    </Card>
  )
}
export default PhotoPreview